import React from 'react';
import { NewPasswordForm, AuthPageLayout } from '@repo/common';

const ForgotPasswordNew = () => {
  return (
    <AuthPageLayout
      title='Set new password'
      subtitle='Choose a new password to secure your account'
    >
      <NewPasswordForm />
    </AuthPageLayout>
  );
};

export default ForgotPasswordNew;
